import { ContextCardType } from "./context-card";

export const ContextCardQuoteCopies: { [key: string]: ContextCardType } = {
  EMPTY: { title: "", description: "" },
  SECOND_LOAN: {
    title: "We've made it quick & simple",
    description:
      "To get your personalised rate just confirm it's all up to date & your good to go",
  },
  PAY_FASTER: {
    title: "Want to pay it off faster?",
    description: "No worries. Our loans don't have early repayment fees.",
  },
  DEBT_SMARTER: {
    title: "Ready to debt smarter?",
    description: "Roll them all into one easy-to-manage monthly repayment.",
  },
  FRESH_COAT: {
    title: "Time for a fresh coat?",
    description: "Add value to your home with a renovation loan.",
  },
  GOOD_COMP_CAR: {
    title: "You're in good company!",
    description: "We've helped thousands of Aussie drivers to hit the road.",
  },
  GOOD_COMP_DEBT: {
    title: "You're in good company!",
    description:
      "Thousands of Aussies have rolled their debts into one - ready to join them?",
  },
  GOOD_COMP_RENO: {
    title: "You're in good company!",
    description: "Thousands of Aussies are sprucing up their homes with Wisr.",
  },
  GOOD_COMP_OTHER: {
    title: "You're in good company!",
    description: "Join over 46,000 Aussies who chose Wisr for their loan.",
  },
};

export const ContextCardApplicationCopies: { [key: string]: ContextCardType } =
  {
    EMPTY: { title: "", description: "" },
    WISE_CHOICE: {
      title: "You've made a wise choice!",
      description:
        "Join over 50,000 Aussies who have achieved their goal with a Wisr loan.",
    },
    DEPEND_ON_US: {
      title: "You can depend on us 🫶",
      description:
        "We're rated excellent for customer experience on Trustpilot with 4.6 out of 5.",
    },
    HALF_WAY_THERE: {
      title: "Woah, you're halfway there!",
      description: "Only a few more clicks to go.",
    },
    FLEXIBLE_LOANS: {
      title: "Our loans are flexible",
      description: "You can change your repayment optionsanytime.",
    },
    ROLL_IT_CONSOLIDATION: {
      title: "Roll it all into one",
      description:
        "With Wisr debt consolidation you'll have one repayment, one interest rate and on loan.",
    },
    ROLL_IT_UNSECURED: {
      title: "Roll it all into one",
      description: "Have you considered a debt consolidation loan?",
    },
    SAME_DAY: {
      title: "Same-day approvals ⚡️",
      description:
        "Your application can be approved in 24 hours if we've got everything we need.",
    },
    LETS_FINISH: {
      title: "Let's finish this!",
      description: "You've got one more click to go",
    },
    AWARD_WINNER: {
      title: "You've picked a winner!",
      description:
        "We're an award-winning lender for a reason, submit your application and find out why",
    },
  };
